module.exports = __webpack_public_path__ + "img/354978291.aab087aa.jpg";